export default __webpack_public_path__ + "static/media/travelEasyOne.86a14f09.png";